/**
 * ** Synxis - Sabre **
 *
 * @exports partnership_6
 * @category partnerships
 */
function factory({ window, document, thn }) {

  const partnership = {};
  const linkToSynxUrl = document.querySelector('a[href^="https://be.synxis.com"]')?.href || document.querySelector('form[id*=bookingFormSynxis]')?.action;

  /**
     * @memberOf module:partnership_6
     */
  partnership.boot = function boot() {

    // We need to use the uppermost selector that includes the Hotel specific heading (on BE pages)
    const container = document.querySelector('.pageWrapper');
    if (!container) {
      return;
    }

    const refreshPartner = thn.debounce(thn.siteCheck, 400);
    thn.observeDom(container, refreshPartner, {
      childList: true,
      subtree: true,
      attribute: true,
      characterData: false,
    });

    partnership.shutdown = () => {
      refreshPartner.cancel();
      thn.stopObserveDom(container, refreshPartner);
    };
  };

  /**
     * @memberOf module:partnership_6
     */
  partnership.getId = function getId() {
    return '6';
  };

  /**
     * @memberOf module:partnership_6
     */
  partnership.check = function check() {
    // Check if we are inside Synxis BE
    return !thn.empty(window._GlobalTokens) || !!linkToSynxUrl || !!window.location.hostname.match(/(synxis.com|book.viennahouse.com|reservation.outrigger.com|booking.barcelo.com|reservation.slh|aman.com|reservation.middleeight|book.standardhotels|booking.castelfalfi|hotel.reservations|rsv\.\w+\.com|reservations.bostonharborhotel|reservations.hotelmonville|bookings.ensanahotels)/);
  };

  /**
     * @memberOf module:partnership_6
     */
  partnership.getSiteId = function getSiteId() {
    // window.location is "https://be.synxis.com/?adult=2&altdest=SWEST&arrive=2020-06-15&chain=15503&child=0&configcode=icelandair¤cy=ISK&depart=2020-06-16&hotel=59628&level=hotel&locale=en-US&rooms=1"
    const beUrl = linkToSynxUrl || window.location;
    const inAmanPage = window.location.hostname.match(/aman.com/) && document.querySelector('#edit-resort-id > option[selected]')?.value;
    let hotelId = beUrl && ((new URL(beUrl)).searchParams.get('hotel') || (new URL(beUrl)).searchParams.get('Hotel') || inAmanPage);
    const hotelIdByInput = document.querySelector('input[name=hotel]')?.value;
    if (!hotelId && window.dataLayer) {
      hotelId = thn.dataLayerHelper.get('HOTEL_ID');
    } else if (!hotelId && window._GlobalTokens && window._GlobalTokens.HOTEL_ID) {
      hotelId = window._GlobalTokens.HOTEL_ID;
    } else if (!hotelId && hotelIdByInput) {
      hotelId = hotelIdByInput;
    }

    if (window.dataLayer && thn.dataLayerHelper.get('ConfigCode') && thn.dataLayerHelper.get('CHAIN_ID') === '5136') {
      hotelId += `_${thn.dataLayerHelper.get('ConfigCode')}`;
    }

    const result = {
      externalId: hotelId,
    };
    return result;
  };

  return partnership;
}

export { factory };
